import { openBlock as t, createElementBlock as a, createStaticVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M.689 25.217a20.035 20.035 0 0 0 14.094 14.094V25.217H.689Z"></path><path fill="#0052B4" d="M14.783.689A20.035 20.035 0 0 0 .689 14.783h14.094V.689Z"></path><path fill="#D80027" d="M39.311 14.783A20.035 20.035 0 0 0 25.218.689v14.094H39.31Z"></path><path fill="#0052B4" d="M25.218 39.311A20.035 20.035 0 0 0 39.31 25.217H25.218v14.094Z"></path><path fill="#496E2D" d="M25.218 20a5.217 5.217 0 1 1-10.435 0c0-2.882 5.217-5.217 5.217-5.217s5.218 2.335 5.218 5.217Z"></path><path fill="#0052B4" d="M14.783 20a5.217 5.217 0 1 1 10.435 0"></path><path fill="#D80027" d="M17.065 17.391v3.261a2.935 2.935 0 0 0 5.87 0v-3.26h-5.87Z"></path>', 8), p = [
  e
];
function i(o, c) {
  return t(), a("svg", h, [...p]);
}
const n = { render: i };
export {
  n as default,
  i as render
};
